document.addEventListener("DOMContentLoaded", function () {
  var video = document.querySelector('#custom-section-video');
  if (!video) return;

  function playVideo() {
    if (video.paused) {
      video.play().catch(function (error) {
        console.log('Video play failed:', error);
      });
    }
  }

  function pauseVideo() {
    if (!video.paused) {
      video.pause();
    }
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        playVideo();
      } else {
        pauseVideo();
      }
    });
  }, { threshold: 0.5 });

  observer.observe(video);
});